import { z } from 'zod/v4';

import { IMAGE_GENERATION_MODEL_OPTIONS, MAX_PROMPT_LENGTH } from './constants';

const imageGenerationFormSchema = z.object({
    prompt: z.string().trim().min(1, 'Prompt is required').max(MAX_PROMPT_LENGTH),
});

export type ImageGenerationFormState = z.infer<typeof imageGenerationFormSchema> & {
    aspectRatio: string;
    model: string;
    resolution: string;
    referenceImages: File[];
    validationActive: boolean;
};

export type ImageGenerationFormErrors = Partial<Record<keyof z.infer<typeof imageGenerationFormSchema>, string>>;

export const IMAGE_GENERATION_FORM_DEFAULTS: ImageGenerationFormState = {
    prompt: '',
    aspectRatio: '16:9',
    model: IMAGE_GENERATION_MODEL_OPTIONS[0].value,
    resolution: '720p',
    referenceImages: [],
    validationActive: false,
};

export function validateImageGenerationForm(state: ImageGenerationFormState): {
    isValid: boolean;
    errors: ImageGenerationFormErrors;
} {
    const result = imageGenerationFormSchema.safeParse(state);
    if (result.success) {
        return { isValid: true, errors: {} };
    }

    const errors: ImageGenerationFormErrors = {};
    for (const issue of result.error.issues) {
        const field = issue.path[0];
        if (typeof field === 'string' && field in IMAGE_GENERATION_FORM_DEFAULTS) {
            errors[field as keyof ImageGenerationFormErrors] = issue.message;
        }
    }
    return { isValid: false, errors };
}
